/**
 * The toile mark — a stretched canvas seen straight on, one tungsten stroke across the blank.
 *
 * Geometry is the canonical SVG from thinking/design/toile/toile_identity.md, kept identical to
 * webapp/public/toile-mark.svg. Inlined rather than served as an <img> so it inherits nothing
 * and paints with the first byte of HTML — it is the landing's only mark.
 *
 * Two rules from the identity sheet the component enforces by construction: the frame is
 * upright and never mirrored (the stroke rises left to right), and the stroke is the single
 * tungsten element. Flat ink — no gradient, shadow or fill.
 */
export function ToileMark({size = 42}: {size?: number}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            role="img"
            aria-label="toile"
        >
            <rect x="12" y="12" width="40" height="40" stroke="#F2EDE4" strokeWidth="2.5"/>
            <path d="M23 41 L41 23" stroke="#FFDFA8" strokeWidth="5" strokeLinecap="round"/>
        </svg>
    )
}
